import React from 'react';
import TextArea from '../../../widgets/TextArea';
import { Typography } from '../../../widgets/Typography';
import Button from '../../../widgets/Button';
import useSubmitManagerFeedback from '../hooks/useSubmitManagerFeedback';
import { useTranslation } from 'react-i18next';

type Props = {
  ratingScore: number;
  onSubmit: () => void;
};

export default function NpsInputTextStep({ onSubmit, ratingScore }: Props) {
  const { t } = useTranslation();
  const [feedback, setFeedback] = React.useState('');

  const { submitFeedback, isSubmitting: isSubmittingFeedback } =
    useSubmitManagerFeedback({
      onSuccess: () => {
        onSubmit();
      },
      onError: () => {
        alert(t('NPS_ERROR'));
      },
    });

  return (
    <div className="flex w-full flex-col items-center justify-start">
      <Typography variant="body-xl" weight="bold" className="mb-4">
        Please share your feedback
      </Typography>
      <div className="flex h-fit w-4/5 flex-col gap-4 md:w-1/2">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            submitFeedback({
              nps: ratingScore,
              additionalFeedback: feedback,
            });
          }}
        >
          <Typography variant="body-sm" weight="medium" className="mb-1.5">
            Tell us more (Optional)
          </Typography>
          <TextArea
            showCharacterCount
            className="h-40 md:h-26"
            placeholder="Tell us more.."
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            maxLength={1500}
          />
          <div className="flex-end flex">
            <Button
              isLoading={isSubmittingFeedback}
              type="submit"
              className="mt-4 ml-auto"
            >
              Send feedback
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
